import { render } from "./OapSkindrAppWrapper.vue?vue&type=template&id=d92afd04"
import script from "./OapSkindrAppWrapper.vue?vue&type=script&lang=js"
export * from "./OapSkindrAppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__